var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.205853 0.184906C0.471922 -0.0695947 0.893928 -0.0602167 1.14843 0.205853L8 7.36886L14.8516 0.205853C15.1061 -0.0602167 15.5281 -0.0695947 15.7941 0.184906C16.0602 0.439408 16.0696 0.861413 15.8151 1.12748L8.48176 8.79415C8.35599 8.92563 8.18195 9 8 9C7.81805 9 7.64401 8.92563 7.51824 8.79415L0.184906 1.12748C-0.0695947 0.861413 -0.0602167 0.439408 0.205853 0.184906Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.80ef04f9729da860481c0293ef4cd8d4.svg";
export { ForwardRef as ReactComponent };